import cN from 'classnames';
import { CatalogItem } from '@/shared/types/catalog';
import Spinner from '@/components/Common/Spinner';
import './index.less';
import { useIsMobileURL } from '@/shared/hooks';
import Link from 'next/link';

interface SupplierBadgesProps {
  product: CatalogItem;
  isProductLoading: boolean;
  factorySpecialties: string[];
}

const SupplierBadges = ({ product, isProductLoading, factorySpecialties }: SupplierBadgesProps) => {
  const isMobile = useIsMobileURL();

  return (
    <div className={cN('supplier-badges-box', { 'supplier-badges-box-mobile': isMobile })}>
      <div className="label">
        <Link href={`/sourcing/suppliers/${product?.catalogCompany?.handle}`}>
          <span>{product?.catalogCompany?.name}</span> also specializes in:
        </Link>
      </div>

      {isProductLoading ? (
        <div className="loading">
          <Spinner width={30} />
        </div>
      ) : (
        <div className="badges">
          {Array.from(factorySpecialties).map((badge) => (
            <span key={badge} className="badge-container">
              <span className="badge">{badge}</span>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default SupplierBadges;
